import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PageNavigationHeader from '../../../components/ui/pageNavigation/PageNavHeader';
import { Edit, Download, Mail, Bot, FileText } from 'lucide-react';
import {UpcomingReleaseNotice} from '../../../components/ui/disclaimers/UpcomingRelease';

const BoardPresentationPage: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleEdit = () => {
    console.log('Edit Board Presentation');
  };

  const handleDownload = () => {
    console.log('Download');
  };

  const handleSendEmail = () => {
    console.log('Send via Email');
  };

  return (
    <div className="w-full h-full overflow-auto bg-background">

      <div className="max-w-8xl mx-auto px-6 pt-6">
        <PageNavigationHeader
            actions={[
                {
                label: "Ask AI",
                onClick: () => navigate(`/assistant`),
                icon: Bot,
                variant: "primary"
                },
                {
                label: "Reports",
                onClick: () => navigate(`/cases/${id}/reports`),
                icon: FileText,
                variant: "primary"
                }
            ]}
        />
      </div>

      <div className="max-w-8xl mx-auto px-6 pt-6">
        <UpcomingReleaseNotice variant='executive-board-ppt'></UpcomingReleaseNotice>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="space-y-8">
          
          {/* Actions Header */}
          <div className="flex items-center justify-end gap-2">
            <button
              onClick={handleEdit}
              className="flex items-center gap-2 px-3 py-2 text-sm border border-gray-200 rounded-md hover:bg-muted transition-colors"
            >
              <Edit className="w-4 h-4" />
              Edit
            </button>
            <button
              onClick={handleDownload}
              className="flex items-center gap-2 px-3 py-2 text-sm border border-gray-200 rounded-md hover:bg-muted transition-colors"
            >
              <Download className="w-4 h-4" />
              Download
            </button>
            <button
              onClick={handleSendEmail}
              className="flex items-center gap-2 px-3 py-2 text-sm border border-gray-200 rounded-md hover:bg-muted transition-colors"
            >
              <Mail className="w-4 h-4" />
              Send via Email
            </button>
          </div>

          {/* Case Overview Section */}
          <div className="bg-card border border-gray-200 rounded-lg p-8">
            <h2 className="text-lg font-semibold text-foreground mb-6">Case Overview</h2>
            <div className="space-y-4 text-sm text-foreground leading-relaxed">
              <p>
                Case SEBI-2024-001 involves allegations of credit fraud and loan misrepresentation against Mr. Rajeev Kumar. 
                The investigation was initiated following reports of multiple loan defaults and suspicious documentation.
              </p>
              <p>
                The case pertains to loan account LN-45821 and involves a total outstanding amount of ₹3 Crores across 
                multiple lending institutions. Key concerns include pattern recognition of intentional defaults and 
                document forgery.
              </p>
            </div>
          </div>

          {/* Modus Operandi Section */}
          <div className="bg-card border border-gray-200 rounded-lg p-8">
            <h2 className="text-lg font-semibold text-foreground mb-6">Modus Operandi</h2>
            <div className="space-y-4 text-sm text-foreground leading-relaxed">
              <p>
                The investigation has revealed a systematic approach to fraudulent activities:
              </p>
              <ul className="space-y-2 ml-6">
                <li>• Application for multiple loans simultaneously across different financial institutions</li>
                <li>• Submission of forged income certificates and employment documents</li>
                <li>• Misrepresentation of existing liabilities and credit history</li>
                <li>• Strategic default pattern to maximize loan amounts before detection</li>
                <li>• Use of multiple contact addresses to delay communication</li>
              </ul>
            </div>
          </div>

          {/* Investigation Summary Section */}
          <div className="bg-card border border-gray-200 rounded-lg p-8">
            <h2 className="text-lg font-semibold text-foreground mb-6">Investigation Summary</h2>
            <div className="space-y-4 text-sm text-foreground leading-relaxed">
              <ul className="space-y-3">
                <li>• Case is sourced by DSA - Andro Sales and login by BSM - Ajeet on 1st June 2022. Loan amount 90 lakhs disbursed in three trench, 20 lakhs disbursed in borrower (B1) and 70L disbursed in both seller (S1 and S2) through cheque.</li>
                <li>• Post loan disbursement only 1 EMI paid by the borrower then borrower/co-borrower skipped from all the address and non-contactable</li>
                <li>• Collateral address visited found locked, TPC confirmed property locked since long time and property ownership confirmed to seller only.</li>
                <li>• Residence address visited; borrower has been shifted to another address post disbursement of X Bank loan.</li>
                <li>• Borrower/Co-borrower/Seller KYC checked with authority, found seller KYC details mismatch with authority record seems misused other's KYC</li>
                <li>• Seller bank account detail checked found dummy account created for receiving the loan amount as seller KYC authority record mismatch.</li>
                <li>• Borrower bank account detail checked, found dummy account created for receiving the loan account as seller KYC authority record mismatch</li>
                <li>• Borrower bank account retrieved, found there was no PAN updated in bank account wherein disbursed loan</li>
                <li>• Property chain document checked with authority record and retrieved CTC reveals that there is no registry executed against X Bank borrower B1 and submitted previous & current sales deed document are fabricated document as per retrieval CTC detail are mismatch</li>
              </ul>
            </div>
          </div>

          {/* Actions & Recommendations Section */}
          <div className="bg-card border border-gray-200 rounded-lg p-8">
            <h2 className="text-lg font-semibold text-foreground mb-6">Actions & Recommendations</h2>
            <div className="space-y-4 text-sm text-foreground leading-relaxed">
              <ul className="space-y-3">
                <li>• ODV of property chain should be done at the time of registry in resale transactions</li>
                <li>• Proper due diligence done by the legal team for (Kapashera Authority caseS) by way of conducting search report and retrieving CTC</li>
                <li>• Borrower's & seller's PAN and Aadhar linkage / Aadhar and mobile linkage to be checked on Aadhar portal. Case refer to FCU manager if mismatch seen.</li>
                <li>• Seller's PAN number must be used to run Doris debtor search.</li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default BoardPresentationPage;